<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <div>

      <p>
        <span class="text-danger" v-if="error">{{ error }}</span>
      </p>

      <template v-if="deletion">
        <p>Are you sure you want to delete <em>'{{ data.text }}'</em> reason?</p>
        <small class="text-danger" v-if="errors.ondelete">{{ errors.ondelete[0] }}</small>
      </template>
      <template v-else>

        <div class="form-group row">
          <label for="input-label" class="col-sm-3 col-form-label">Reason Text:</label>
          <div class="col-sm-9">
            <input type="text" name="text" id="input-label" class="form-control form-control-sm" required="required"
                   v-model="data.text">
            <small class="text-danger" v-if="errors.text">{{ errors.text[0] }}</small>
          </div>
        </div>

        <div class="form-group row">
          <div class="offset-sm-3 col-sm-9">
            <label class="mr-2">
              <input type="checkbox" name="status" v-model="data.status">
              Active
            </label>
            <br>
            <template v-if="errors.status">
              <small class="text-danger">{{ errors.status[0] }}</small>
              <br>
            </template>
          </div>
        </div>

      </template>
    </div>

    <template #footer>
      <template v-if="deletion">
        <button type="button" class="btn btn-default" @click="cancelDeletion"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="button" class="btn btn-danger" @click="submit"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting" @click="prepareDeletion"><i class="fa fa-fw fa-trash"></i> Delete</button>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="button" class="btn btn-primary" :disabled="isEmpty" @click="submit"><i class="fa fa-fw fa-upload"></i> Save changes</button>
      </template>
    </template>

  </modal>

</template>

<script>
import HasModal from "./mixins/HasModal";

export default {
  mixins: [HasModal],

  props: {

    id: {
      type: Number,
      default: 0
    },
    modalId: {
      type: String,
      default: 'lookup-diary_date_reason-item-modal'
    },
    text: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: true
    },
  },

  data() {

    return {
      data: {
        text: this.text,
        status: this.status,
      },
      error: '',
      errors: [],
      deletion: false,
    };

  },
  computed: {
    title() {
      if (this.deletion) return "Delete Reason";
      return this.isNew ? "Add Reason" : "Edit Reason";
    },
    method() {
      if (this.deletion) return "DELETE";
      return this.isNew ? "POST" : "PATCH";
    },
    actionUrl() {
      if (this.deletion) return '/admin/lookup/diary-date-reasons/' + this.id;
      return this.isNew ? '/admin/lookup/diary-date-reasons' : '/admin/lookup/diary-date-reasons/' + this.id;
    },
    hasData() {
      return !!(this.data.text && this.data.text.trim().length);
    },
    isEmpty() {
      return !this.hasData;
    },
    isExisting() {
      return this.id > 0;
    },
    isNew() {
      return !this.isExisting;
    }
  },
  methods: {
    /**
     * Submit create/update/delete.
     */
    submit() {
      this.error = '';
      this.errors = Object.assign(this.errors, {});

      let formData = this.formData();
      axios.post(this.actionUrl, formData)
          .then(response => {
            window.location.reload();
          })
          .catch(error => {
            this.handleErrors(error, 'Unable to complete the action.')
          });
    },

    /**
     * Prepare form data.
     */
    formData() {
      const formData = new FormData();

      Object.keys(this.data).forEach(fieldName => {
        const value = this.data[fieldName] ? this.data[fieldName] : '';
        if (Array.isArray(this.data[fieldName])) {
          value.forEach(item => {
            formData.append(fieldName + '[]', item);
          })
        } else {
          formData.append(fieldName, value);
        }
      });

      formData.append('_method', this.method);
      return formData;
    },

    /**
     * Handle axios errors
     *
     * @param errorObj
     * @param defaultMessage
     */
    handleErrors(errorObj, defaultMessage) {
      if (errorObj.response.status === 422) {
        this.errors = errorObj.response.data.errors || {};
      } else {
        this.error = defaultMessage;
      }
    },

    prepareDeletion() {
      this.deletion = true;
    },

    cancelDeletion() {
      this.deletion = false;
    },
  }
}

</script>
